/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import VueConfetti from "vue-confetti";
import Trend from "vuetrend";

window.Vue = Vue;
window.Event = new window.Vue();
window.Vue.use(Trend);
window.Vue.use(VueConfetti);
window.Vue.use(VueClipboard);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context("./", true, /\.vue$/i);
files
    .keys()
    .map((key) =>
        Vue.component(key.split("/").pop().split(".")[0], files(key).default)
    );

/**
 * Third party components
 */
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import VueTagsInput from "@johmun/vue-tags-input";
Vue.component("vue-tags-input", VueTagsInput);

import VueTimepicker from "vue2-timepicker/src/index";
Vue.component("vue-timepicker", VueTimepicker);

import PrettyCheck from "pretty-checkbox-vue/check";
Vue.component("p-check", PrettyCheck);

/**
 * Icons
 */
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faCcAmex,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
    faCcMastercard,
    faCcVisa,
    faProductHunt,
    faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
    faCheckCircle,
    faHandPointUp,
    faLightbulb,
    faQuestionCircle,
    faStopCircle,
    faThumbsDown,
    faThumbsUp,
} from "@fortawesome/free-regular-svg-icons";
import {
    faArrowLeft,
    faAt,
    faBomb,
    faBookOpen,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faCheck,
    faChevronDown,
    faChevronUp,
    faClock,
    faCog,
    faCopy,
    faCreditCard,
    faDownload,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEye,
    faFolderOpen,
    faGlassCheers,
    faGlobe,
    faMagic,
    faMailBulk,
    faMapSigns,
    faMinus,
    faMoneyCheckAlt,
    faPaperPlane,
    faPen,
    faPlus,
    faQuoteLeft,
    faSearch,
    faShippingFast,
    faSignOutAlt,
    faStar,
    faTimes,
    faToggleOn,
    faTrashAlt,
    faUser,
    faUserAstronaut,
    faUsers,
    faNewspaper
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
    faTwitter,
    faProductHunt,
    faStopCircle,
    faCaretLeft,
    faCaretRight,
    faArrowLeft,
    faCaretDown,
    faPlus,
    faDownload,
    faCheck,
    faTimes,
    faCog,
    faStar,
    faShippingFast,
    faCcVisa,
    faCcAmex,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
    faCcMastercard,
    faCreditCard,
    faEllipsisH,
    faPaperPlane,
    faThumbsUp,
    faThumbsDown,
    faBomb,
    faMinus,
    faAt,
    faGlobe,
    faQuoteLeft,
    faSearch,
    faMapSigns,
    faChevronDown,
    faChevronUp,
    faSignOutAlt,
    faMoneyCheckAlt,
    faUser,
    faTrashAlt,
    faQuestionCircle,
    faFolderOpen,
    faLightbulb,
    faHandPointUp,
    faCheckCircle,
    faGlassCheers,
    faStar,
    faClock,
    faToggleOn,
    faUserAstronaut,
    faCopy,
    faMailBulk,
    faPen,
    faUsers,
    faMagic,
    faEllipsisV,
    faEdit,
    faEye,
    faBookOpen,
    faNewspaper
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app",
});
